import { AnalyticsActionType, AnalyticsState } from 'types/analytics';

export const initialAnalyticsState: AnalyticsState = {
  eventType: '',
  parameters: {},
};

export const analyticsReducer = (state: AnalyticsState = initialAnalyticsState, action: AnalyticsActionType): AnalyticsState => {
  switch (action.type) {
    case 'TRACK_PAGE':
    case 'TRACK_CLICK':
    case 'TRACK_FORM_SUBMIT':
    case 'TRACK_SYSTEM_ERROR':
    case 'IDENTIFY_USER':
      return {
        ...state,
        eventType: action.payload.eventType,
        parameters: action.payload.parameters,
      };

    default:
      return state;
  }
};
